<template>
  <b-select
    v-model="form.statusId"
    :error-messages="getErrorMessages(v$.statusId)"
    label="Статус недоліку"
    :items="
      $directory.get('incidentIssueStatuses', dialog.dialogData.issue.status)
    "
    @focus="$directory.fill('incidentIssueStatuses')">
  </b-select>
</template>

<script lang="ts">
import { PropType, reactive } from 'vue'
import { Dialog } from '@/dialog'
import { getErrorMessages } from 'best-modules/utils'
import { BSelect } from 'best-modules/components/index'
import { required } from '@vuelidate/validators'
import { useVuelidate } from '@/plugins'
import { incidentIssueSetStatus } from '@/requests/incident'
import { setSnackbar } from 'best-modules/plugins'

export default {
  name: 'IncidentIssueSetStatus',
  components: { BSelect },
  props: {
    dialog: {
      type: Object as PropType<Dialog>,
      required: true,
    },
  },
  methods: {
    getErrorMessages,
  },
  setup(props) {
    const form = reactive({
      statusId: props.dialog.dialogData.issue.statusId || null,
    })

    const rules = {
      statusId: { required },
    }

    const v$ = useVuelidate(rules, form)

    const submit = () => {
      return incidentIssueSetStatus(
        props.dialog.dialogData.issue.id,
        form
      ).then(issue => {
        setSnackbar({ text: 'Статус недоліку оновлено' })
        return issue
      })
    }

    return {
      submit,
      form,
      v$,
    }
  },
}
</script>

<style scoped lang="scss"></style>
